module.exports = __webpack_public_path__ + "img/icon_map_63_off_011.3cdd2d68.png";